// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sectionWrapper_XqTpA {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 20px;
}
.infoContainerWrapper_IQtHe {
  display: flex;
  align-items: center;
  gap: 22px;
  padding: 0;
  justify-content: space-between;
}
.infoContainer_Be7sl {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0;
  padding: 0;
  div {
    color: #1f184b;
    font-size: 12px;
    font-weight: 500;
  }
  span {
    max-width: 360px;
    color: #1f184b;
    font-size: 12px;
    font-weight: 300;
  }
}

.contentContainer_Qme94 {
  &.active_XGk3M {
    display: block;
  }
  &.disabled_Ax9BL {
    display: none;
  }
}

.contentInput_nFVKc {
  margin-top: 0px;
  display: flex;
  flex-direction: column;
}

.titleContentInput_WdKD5 {
  color: #1f184b;
  font-size: 13px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 0px solid #e8e8e8;
  border-top: 0px solid #e8e8e8;
  margin-top: 0px;
  margin-bottom: 0px;
  .optionsContentInput_cz3UF {
    display: flex;
    align-items: center;
    gap: 10px;
  }
}

.titleContentInputFromRulesFilter_gTYNW {
  color: #1f184b;
  font-size: 18px;
  line-height: 1;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0;
  .optionsContentInput_cz3UF {
    display: flex;
    align-items: center;
    gap: 10px;
  }
}

.cardTypesContainer_QkS1B {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin: 9px 0;
}
.singleTypeCard_CEYoF {
  display: flex;
  gap: 9px;
  padding: 3px 12px;
  border-radius: 30px;
  border: 1px solid #e0e3e6;
  span {
    font-size: 12px;
    font-weight: 400;
    color: #2a2e32;
    -webkit-user-select: none;
            user-select: none;
  }
}
.minusIcon_EBpUs {
  height: 13px;
  margin-top: 1px;
  width: 13px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border-radius: 50%;
  background: #dc3545;
  display: flex;
  align-items: center;
  justify-content: center;
}


.subtitleContentInput_bQbqd {
  font-weight: 300;
  font-size: 11;
  color: #18181b;
}
.quantityContainer_wi3bm {
  display: flex;
  gap: 10px;
  align-items: center;

  .quantityContent_B8urt {
    gap: 10px;
    flex: 1 1;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    color: #1e0045;
    input {
      background-color: var(--f5-background);
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 32px;
      border-radius: 4px;
      padding: 0px 18px;
      font-family: "Inter", sans-serif;
      border: none;
      outline: none;
    }
  }
  p {
    margin: 0;
    height: fit-content;
  }
}
.currencyContainer_SJiKu {
  color: #264f88;
  font-weight: bold;
  border-bottom: 2px solid #264f88;
  gap: 5px;
  display: flex;
  align-items: center;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  position: relative;
  div {
    gap: 5px;
  }
}

.currencyDropdownButton_ryc1b {
  display: flex;
  gap: 5px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  position: relative;
}
.chevronIcon_aPW18 {
  margin-top: 3px;
}
.currencyDropdown_t8S9v {
  position: absolute;
  top: 97%;
  left: -4%;
  width: 108%;
  display: flex;
  flex-direction: column;
  background-color: var(--f4-background);
  border-radius: 4px;
  color: #264f88;
  font-size: 14px;
  box-shadow: 0 2px 4px var(--_0000001a-shadow);
  z-index: 1;
  overflow: hidden;

  span {
    display: flex;
    padding: 1px 2px;
    align-items: center;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    justify-content: flex-start;
    &:hover {
      background-color: var(--ececf1-background);
    }
  }
}

.conditionsContainer_rfGfz {
  display: flex;
  padding: 5px 9px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  gap: 10px;
  align-self: stretch;
  border-radius: 5px;
  background: var(--f4-background);
  .conditions_XfdRh {
    display: flex;
    width: 100%;
    gap: 10px;
    flex-wrap: wrap;
    .condition_HNEX8 {
      display: flex;
      padding: 6px 12px;
      align-items: center;
      gap: 8px;
      border-radius: 30px;
      border: 1px solid #e0e3e6;
      background: var(--white-background);
      -webkit-border-radius: 30px;
      -moz-border-radius: 30px;
      -ms-border-radius: 30px;
      -o-border-radius: 30px;
      color: #2a2e32;
      font-family: Inter;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      overflow: hidden;
      textarea,
      input,
      span {
        font-family: "Inter", sans-serif;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        overflow: hidden;
        border: none;
        padding: 0;
      }
    }
    .conditionInput_B94Se {
      outline: none;
      border: none;
      resize: none;
      field-sizing: content;
    }
  }
  input {
    background-color: transparent;
    border: none;
    outline: none;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px; 
    box-sizing: border-box;
    &::placeholder {
      color: var(--_71717a-color);
      font-family: Inter;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 21px; 
    }
  }
}

.labelName_XKh0U input {
  display: flex;
  height: 32px;
  padding: 6px 8px;
  justify-content: space-between;
  align-items: center;
  flex: 1 0;
  border-radius: 4px;
  outline: none;
  border: none;
  color: #000000;
  font-size: 14px;
  font-weight: 400;

  &::placeholder {
    color: #000000;
  }
}
.labelName_XKh0U input:not([disabled]) {    
  background-color: var(--f4-background);
  border-radius: 5px;
  box-sizing: border-box;
  width: 100%;
  padding: 12px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
}
.filtersLabelOptions_PBpFZ {
  border-left: 1px solid #c3c3c3;
  display: flex;
  padding-left: 22px;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  p {
    margin: 5px;
  }
}

.changeTypeContainerButton_JjzSi {
  display: flex;
  width: 100%;
  display: flex;
  height: 50px;
  padding: 6px 5px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 12px;
  background: var(--f9-background);
  > button {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex: 1 0;
    border-radius: 8px;
    box-shadow:
      0px 0px 2px 0px rgba(0, 0, 0, 0.03),
      0px 0px 0px 0px rgba(0, 0, 0, 0),
      0px 0px 0px 0px rgba(0, 0, 0, 0);
    background-color: transparent;
    outline: none;
    border: 1px solid transparent;
    color: var(--_b4-color);
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; 
  }
  .typeFilterBtn_UO67V {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex: 1 0;
    border-radius: 8px;
    border: 1px solid var(--_0000001a-shadow);
    background: var(--white-background);
    box-shadow:
      0px 0px 2px 0px rgba(0, 0, 0, 0.03),
      0px 0px 0px 0px rgba(0, 0, 0, 0),
      0px 0px 0px 0px rgba(0, 0, 0, 0);
    color: #0d0d0d;
  }
}
.buttonAddFilter_HR_vx {
  display: flex;
  height: fit-content;
  padding: 14px 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  border: 1px solid #cbcbcb;
  background: var(--white-background);
  cursor: pointer;
  flex: 1 1;
  box-sizing: border-box;
  width: 100%;
}


.keywordContainer_EeQrF {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin: 4px 0;
  .keyword_IGSHA {
    display: flex;
    gap: 9px;
    padding: 3px 12px;
    border-radius: 30px;
    border: 1px solid #e0e3e6;
    align-items: center;
  }
}
.buttonsTypeConditionAbsolute_bSsvm {
  display: flex;
  width: 70px;
  height: 28px;
  box-sizing: border-box;
  margin-top: 15px;
  position: absolute;
  right: 5px;
  top: -5px;
  cursor: pointer;
  border-radius: 99px;
  border: 1px solid #cbcbcb;
  justify-content: center;
  align-items: center;
  padding: 10px;
  background-color: var(--white-background);
}


.labelNameFromRulesFilter_QJON4 {
  width: 100%;
}

.labelNameFromRulesFilter_QJON4 input {
  display: flex;
  height: 32px;
  padding: 6px 8px;
  justify-content: space-between;
  align-items: center;
  flex: 1 0;
  border-radius: 4px;
  outline: none;
  border: none;
  color: #000000;
  font-size: 14px;
  font-weight: 400;

  &::placeholder {
    color: #000000;
  }
}
.labelNameFromRulesFilter_QJON4 input:not([disabled]) {
  background-color: var(--f4-background);
  border-radius: 5px;
  box-sizing: border-box;
  width: 100%;
  padding: 12px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
}

.buttonsAddFilter_OV_cr {
  display: flex;
  gap: 10px;
  width: 100%;
}

.buttonAplyFilter_sYi2F {
  display: flex;
  height: fit-content;
  padding: 14px 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  border: 0px solid #cbcbcb;
  background: var(--_10a37f-background);
  cursor: pointer;
  flex: 1 1;
  box-sizing: border-box;
  width: 100%;
  color: var(--white-background);
}

.buttonsAddFilter_OV_cr {
  display: flex;
  gap: 10px;
  width: 100%;
  justify-content: end;
}

.buttonRetry_iG303 {
  display: flex;
  height: fit-content;
  padding: 10px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  border: 0px solid #cbcbcb;
  background: transparent;
  font-size: 14px;
  font-family: Roboto;
  font-weight: 400;
  line-height: 21px;
  color: #636363;
  cursor: pointer;
}

.buttonRetry_iG303:hover {
  background-color: var(--_e6-color);
}

.descriptionInput_sziBu {
  width: 535px;
  height: 100%;
  border: 1px solid var(--e0-border);
  border-radius: 4px;
  padding: 10px;
  margin-bottom: 5px;
  outline: none;
}

.labelContainer_rTFD4 {
  display: flex;
  flex-direction: column;
  background: var(--white-background);
  padding: 10px;
  margin: 8px 0;
  border-radius: 5px;
  box-shadow: 0 2px 5px var(--_00000033-shadow);
  transition: background 0.2s ease;
}

.labelContainer_rTFD4:hover {
  background: #f8f9fa;
}


.loaderGenerar__sFFD {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  position: relative;
  animation: rotate_avinp 1s linear infinite;
}
.loaderGenerar__sFFD::before {
  content: "";
  box-sizing: border-box;
  position: absolute;
  inset: 0px;
  border-radius: 50%;
  border: 5px solid var(--white-background);
  animation: prixClipFix_VEuqt 2s linear infinite;
}

@keyframes rotate_avinp {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes prixClipFix_VEuqt {
  0% {
    clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);
  }
  25% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0);
  }
  50% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 100% 100%, 100% 100%);
  }
  75% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%);
  }
  100% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Automate/Components/FiltersAndVariablesOut/FiltersAndVariablesOut.module.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,MAAM;EACN,UAAU;EACV;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;EAChC,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,aAAa;AACf;AACA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAiB;YAAjB,iBAAiB;EACnB;AACF;AACA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;;AAGA;EACE,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;;EAEnB;IACE,SAAS;IACT,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd;MACE,sCAAsC;MACtC,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,YAAY;MACZ,kBAAkB;MAClB,iBAAiB;MACjB,gCAAgC;MAChC,YAAY;MACZ,aAAa;IACf;EACF;EACA;IACE,SAAS;IACT,mBAAmB;EACrB;AACF;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,gCAAgC;EAChC,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB;IACE,QAAQ;EACV;AACF;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,sCAAsC;EACtC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,6CAA6C;EAC7C,UAAU;EACV,gBAAgB;;EAEhB;IACE,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,2BAA2B;IAC3B;MACE,0CAA0C;IAC5C;EACF;AACF;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC;IACE,aAAa;IACb,WAAW;IACX,SAAS;IACT,eAAe;IACf;MACE,aAAa;MACb,iBAAiB;MACjB,mBAAmB;MACnB,QAAQ;MACR,mBAAmB;MACnB,yBAAyB;MACzB,mCAAmC;MACnC,2BAA2B;MAC3B,wBAAwB;MACxB,uBAAuB;MACvB,sBAAsB;MACtB,cAAc;MACd,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;MACjB,gBAAgB;MAChB;;;QAGE,gCAAgC;QAChC,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;QAChB,YAAY;QACZ,UAAU;MACZ;IACF;IACA;MACE,aAAa;MACb,YAAY;MACZ,YAAY;MACZ,qBAAqB;IACvB;EACF;EACA;IACE,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB;MACE,2BAA2B;MAC3B,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;IACnB;EACF;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAW;EACX,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;;EAEhB;IACE,cAAc;EAChB;AACF;AACA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,SAAW;IACX,kBAAkB;IAClB;;;sCAGkC;IAClC,6BAA6B;IAC7B,aAAa;IACb,6BAA6B;IAC7B,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,SAAW;IACX,kBAAkB;IAClB,yCAAyC;IACzC,mCAAmC;IACnC;;;sCAGkC;IAClC,cAAc;EAChB;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mCAAmC;EACnC,eAAe;EACf,SAAO;EACP,sBAAsB;EACtB,WAAW;AACb;;;AAGA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,aAAa;EACb;IACE,aAAa;IACb,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;EACrB;AACF;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;;AAGA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAW;EACX,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;;EAEhB;IACE,cAAc;EAChB;AACF;AACA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,qCAAqC;EACrC,eAAe;EACf,SAAO;EACP,sBAAsB;EACtB,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mCAAmC;EACnC,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,6CAA6C;EAC7C,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,0CAAoC;AACtC;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,yCAAyC;EACzC,+CAAyC;AAC3C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,oDAAoD;EACtD;EACA;IACE,gEAAgE;EAClE;EACA;IACE,yEAAyE;EAC3E;EACA;IACE,mEAAmE;EACrE;EACA;IACE,gEAAgE;EAClE;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap\");\n\n.sectionWrapper {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  gap: 20px;\n}\n.infoContainerWrapper {\n  display: flex;\n  align-items: center;\n  gap: 22px;\n  padding: 0;\n  justify-content: space-between;\n}\n.infoContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 0;\n  padding: 0;\n  div {\n    color: #1f184b;\n    font-size: 12px;\n    font-weight: 500;\n  }\n  span {\n    max-width: 360px;\n    color: #1f184b;\n    font-size: 12px;\n    font-weight: 300;\n  }\n}\n\n.contentContainer {\n  &.active {\n    display: block;\n  }\n  &.disabled {\n    display: none;\n  }\n}\n\n.contentInput {\n  margin-top: 0px;\n  display: flex;\n  flex-direction: column;\n}\n\n.titleContentInput {\n  color: #1f184b;\n  font-size: 13px;\n  line-height: 1;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 0px solid #e8e8e8;\n  border-top: 0px solid #e8e8e8;\n  margin-top: 0px;\n  margin-bottom: 0px;\n  .optionsContentInput {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n}\n\n.titleContentInputFromRulesFilter {\n  color: #1f184b;\n  font-size: 18px;\n  line-height: 1;\n  margin-bottom: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 10px 0;\n  .optionsContentInput {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n}\n\n.cardTypesContainer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin: 9px 0;\n}\n.singleTypeCard {\n  display: flex;\n  gap: 9px;\n  padding: 3px 12px;\n  border-radius: 30px;\n  border: 1px solid #e0e3e6;\n  span {\n    font-size: 12px;\n    font-weight: 400;\n    color: #2a2e32;\n    user-select: none;\n  }\n}\n.minusIcon {\n  height: 13px;\n  margin-top: 1px;\n  width: 13px;\n  cursor: pointer;\n  user-select: none;\n  border-radius: 50%;\n  background: #dc3545;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n\n.subtitleContentInput {\n  font-weight: 300;\n  font-size: 11;\n  color: #18181b;\n}\n.quantityContainer {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n\n  .quantityContent {\n    gap: 10px;\n    flex: 1;\n    display: flex;\n    align-items: center;\n    box-sizing: border-box;\n    color: #1e0045;\n    input {\n      background-color: var(--f5-background);\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      height: 32px;\n      border-radius: 4px;\n      padding: 0px 18px;\n      font-family: \"Inter\", sans-serif;\n      border: none;\n      outline: none;\n    }\n  }\n  p {\n    margin: 0;\n    height: fit-content;\n  }\n}\n.currencyContainer {\n  color: #264f88;\n  font-weight: bold;\n  border-bottom: 2px solid #264f88;\n  gap: 5px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  user-select: none;\n  position: relative;\n  div {\n    gap: 5px;\n  }\n}\n\n.currencyDropdownButton {\n  display: flex;\n  gap: 5px;\n  cursor: pointer;\n  user-select: none;\n  position: relative;\n}\n.chevronIcon {\n  margin-top: 3px;\n}\n.currencyDropdown {\n  position: absolute;\n  top: 97%;\n  left: -4%;\n  width: 108%;\n  display: flex;\n  flex-direction: column;\n  background-color: var(--f4-background);\n  border-radius: 4px;\n  color: #264f88;\n  font-size: 14px;\n  box-shadow: 0 2px 4px var(--_0000001a-shadow);\n  z-index: 1;\n  overflow: hidden;\n\n  span {\n    display: flex;\n    padding: 1px 2px;\n    align-items: center;\n    cursor: pointer;\n    user-select: none;\n    justify-content: flex-start;\n    &:hover {\n      background-color: var(--ececf1-background);\n    }\n  }\n}\n\n.conditionsContainer {\n  display: flex;\n  padding: 5px 9px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-end;\n  gap: 10px;\n  align-self: stretch;\n  border-radius: 5px;\n  background: var(--f4-background);\n  .conditions {\n    display: flex;\n    width: 100%;\n    gap: 10px;\n    flex-wrap: wrap;\n    .condition {\n      display: flex;\n      padding: 6px 12px;\n      align-items: center;\n      gap: 8px;\n      border-radius: 30px;\n      border: 1px solid #e0e3e6;\n      background: var(--white-background);\n      -webkit-border-radius: 30px;\n      -moz-border-radius: 30px;\n      -ms-border-radius: 30px;\n      -o-border-radius: 30px;\n      color: #2a2e32;\n      font-family: Inter;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 20px;\n      overflow: hidden;\n      textarea,\n      input,\n      span {\n        font-family: \"Inter\", sans-serif;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 20px;\n        overflow: hidden;\n        border: none;\n        padding: 0;\n      }\n    }\n    .conditionInput {\n      outline: none;\n      border: none;\n      resize: none;\n      field-sizing: content;\n    }\n  }\n  input {\n    background-color: transparent;\n    border: none;\n    outline: none;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 21px; \n    box-sizing: border-box;\n    &::placeholder {\n      color: var(--_71717a-color);\n      font-family: Inter;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 21px; \n    }\n  }\n}\n\n.labelName input {\n  display: flex;\n  height: 32px;\n  padding: 6px 8px;\n  justify-content: space-between;\n  align-items: center;\n  flex: 1 0 0;\n  border-radius: 4px;\n  outline: none;\n  border: none;\n  color: #000000;\n  font-size: 14px;\n  font-weight: 400;\n\n  &::placeholder {\n    color: #000000;\n  }\n}\n.labelName input:not([disabled]) {    \n  background-color: var(--f4-background);\n  border-radius: 5px;\n  box-sizing: border-box;\n  width: 100%;\n  padding: 12px;\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  -ms-border-radius: 5px;\n  -o-border-radius: 5px;\n}\n.filtersLabelOptions {\n  border-left: 1px solid #c3c3c3;\n  display: flex;\n  padding-left: 22px;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  align-self: stretch;\n  p {\n    margin: 5px;\n  }\n}\n\n.changeTypeContainerButton {\n  display: flex;\n  width: 100%;\n  display: flex;\n  height: 50px;\n  padding: 6px 5px;\n  align-items: center;\n  gap: 10px;\n  align-self: stretch;\n  border-radius: 12px;\n  background: var(--f9-background);\n  > button {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    flex: 1 0 0;\n    border-radius: 8px;\n    box-shadow:\n      0px 0px 2px 0px rgba(0, 0, 0, 0.03),\n      0px 0px 0px 0px rgba(0, 0, 0, 0),\n      0px 0px 0px 0px rgba(0, 0, 0, 0);\n    background-color: transparent;\n    outline: none;\n    border: 1px solid transparent;\n    color: var(--_b4-color);\n    font-family: Inter;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px; \n  }\n  .typeFilterBtn {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    flex: 1 0 0;\n    border-radius: 8px;\n    border: 1px solid var(--_0000001a-shadow);\n    background: var(--white-background);\n    box-shadow:\n      0px 0px 2px 0px rgba(0, 0, 0, 0.03),\n      0px 0px 0px 0px rgba(0, 0, 0, 0),\n      0px 0px 0px 0px rgba(0, 0, 0, 0);\n    color: #0d0d0d;\n  }\n}\n.buttonAddFilter {\n  display: flex;\n  height: fit-content;\n  padding: 14px 24px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 8px;\n  border: 1px solid #cbcbcb;\n  background: var(--white-background);\n  cursor: pointer;\n  flex: 1;\n  box-sizing: border-box;\n  width: 100%;\n}\n\n\n.keywordContainer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin: 4px 0;\n  .keyword {\n    display: flex;\n    gap: 9px;\n    padding: 3px 12px;\n    border-radius: 30px;\n    border: 1px solid #e0e3e6;\n    align-items: center;\n  }\n}\n.buttonsTypeConditionAbsolute {\n  display: flex;\n  width: 70px;\n  height: 28px;\n  box-sizing: border-box;\n  margin-top: 15px;\n  position: absolute;\n  right: 5px;\n  top: -5px;\n  cursor: pointer;\n  border-radius: 99px;\n  border: 1px solid #cbcbcb;\n  justify-content: center;\n  align-items: center;\n  padding: 10px;\n  background-color: var(--white-background);\n}\n\n\n.labelNameFromRulesFilter {\n  width: 100%;\n}\n\n.labelNameFromRulesFilter input {\n  display: flex;\n  height: 32px;\n  padding: 6px 8px;\n  justify-content: space-between;\n  align-items: center;\n  flex: 1 0 0;\n  border-radius: 4px;\n  outline: none;\n  border: none;\n  color: #000000;\n  font-size: 14px;\n  font-weight: 400;\n\n  &::placeholder {\n    color: #000000;\n  }\n}\n.labelNameFromRulesFilter input:not([disabled]) {\n  background-color: var(--f4-background);\n  border-radius: 5px;\n  box-sizing: border-box;\n  width: 100%;\n  padding: 12px;\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  -ms-border-radius: 5px;\n  -o-border-radius: 5px;\n}\n\n.buttonsAddFilter {\n  display: flex;\n  gap: 10px;\n  width: 100%;\n}\n\n.buttonAplyFilter {\n  display: flex;\n  height: fit-content;\n  padding: 14px 24px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 8px;\n  border: 0px solid #cbcbcb;\n  background: var(--_10a37f-background);\n  cursor: pointer;\n  flex: 1;\n  box-sizing: border-box;\n  width: 100%;\n  color: var(--white-background);\n}\n\n.buttonsAddFilter {\n  display: flex;\n  gap: 10px;\n  width: 100%;\n  justify-content: end;\n}\n\n.buttonRetry {\n  display: flex;\n  height: fit-content;\n  padding: 10px 16px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 8px;\n  border: 0px solid #cbcbcb;\n  background: transparent;\n  font-size: 14px;\n  font-family: Roboto;\n  font-weight: 400;\n  line-height: 21px;\n  color: #636363;\n  cursor: pointer;\n}\n\n.buttonRetry:hover {\n  background-color: var(--_e6-color);\n}\n\n.descriptionInput {\n  width: 535px;\n  height: 100%;\n  border: 1px solid var(--e0-border);\n  border-radius: 4px;\n  padding: 10px;\n  margin-bottom: 5px;\n  outline: none;\n}\n\n.labelContainer {\n  display: flex;\n  flex-direction: column;\n  background: var(--white-background);\n  padding: 10px;\n  margin: 8px 0;\n  border-radius: 5px;\n  box-shadow: 0 2px 5px var(--_00000033-shadow);\n  transition: background 0.2s ease;\n}\n\n.labelContainer:hover {\n  background: #f8f9fa;\n}\n\n\n.loaderGenerar {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  position: relative;\n  animation: rotate 1s linear infinite;\n}\n.loaderGenerar::before {\n  content: \"\";\n  box-sizing: border-box;\n  position: absolute;\n  inset: 0px;\n  border-radius: 50%;\n  border: 5px solid var(--white-background);\n  animation: prixClipFix 2s linear infinite;\n}\n\n@keyframes rotate {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes prixClipFix {\n  0% {\n    clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);\n  }\n  25% {\n    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0);\n  }\n  50% {\n    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 100% 100%, 100% 100%);\n  }\n  75% {\n    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%);\n  }\n  100% {\n    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sectionWrapper": `sectionWrapper_XqTpA`,
	"infoContainerWrapper": `infoContainerWrapper_IQtHe`,
	"infoContainer": `infoContainer_Be7sl`,
	"contentContainer": `contentContainer_Qme94`,
	"active": `active_XGk3M`,
	"disabled": `disabled_Ax9BL`,
	"contentInput": `contentInput_nFVKc`,
	"titleContentInput": `titleContentInput_WdKD5`,
	"optionsContentInput": `optionsContentInput_cz3UF`,
	"titleContentInputFromRulesFilter": `titleContentInputFromRulesFilter_gTYNW`,
	"cardTypesContainer": `cardTypesContainer_QkS1B`,
	"singleTypeCard": `singleTypeCard_CEYoF`,
	"minusIcon": `minusIcon_EBpUs`,
	"subtitleContentInput": `subtitleContentInput_bQbqd`,
	"quantityContainer": `quantityContainer_wi3bm`,
	"quantityContent": `quantityContent_B8urt`,
	"currencyContainer": `currencyContainer_SJiKu`,
	"currencyDropdownButton": `currencyDropdownButton_ryc1b`,
	"chevronIcon": `chevronIcon_aPW18`,
	"currencyDropdown": `currencyDropdown_t8S9v`,
	"conditionsContainer": `conditionsContainer_rfGfz`,
	"conditions": `conditions_XfdRh`,
	"condition": `condition_HNEX8`,
	"conditionInput": `conditionInput_B94Se`,
	"labelName": `labelName_XKh0U`,
	"filtersLabelOptions": `filtersLabelOptions_PBpFZ`,
	"changeTypeContainerButton": `changeTypeContainerButton_JjzSi`,
	"typeFilterBtn": `typeFilterBtn_UO67V`,
	"buttonAddFilter": `buttonAddFilter_HR_vx`,
	"keywordContainer": `keywordContainer_EeQrF`,
	"keyword": `keyword_IGSHA`,
	"buttonsTypeConditionAbsolute": `buttonsTypeConditionAbsolute_bSsvm`,
	"labelNameFromRulesFilter": `labelNameFromRulesFilter_QJON4`,
	"buttonsAddFilter": `buttonsAddFilter_OV_cr`,
	"buttonAplyFilter": `buttonAplyFilter_sYi2F`,
	"buttonRetry": `buttonRetry_iG303`,
	"descriptionInput": `descriptionInput_sziBu`,
	"labelContainer": `labelContainer_rTFD4`,
	"loaderGenerar": `loaderGenerar__sFFD`,
	"rotate": `rotate_avinp`,
	"prixClipFix": `prixClipFix_VEuqt`
};
export default ___CSS_LOADER_EXPORT___;
